export default __webpack_public_path__ + "static/media/location.45c1b016.svg";